export default __webpack_public_path__ + "static/media/21_Epi_GG-Quiz-Art_ActiveCooler_Platinum_VOG.3b982cc2.png";